import { ViewSalesFunnelPageHeader } from '@pages/SalesFunnels/ViewSalesFunnel/components/ViewSalesFunnelPageHeader';

export { ViewSalesFunnelPageHeader };
